/** Плавающее меню массовых действий над выбранными строками (порт updateBulkActionMenu,
 * стр. 7166-7195): раскраска строк, снятие выбора, снятие цвета. */
import React, { useState } from "react";

import { Button } from "@/components/ui/button";

export function BulkActionMenu({
  count,
  canEdit,
  onPaint,
  onClearColor,
  onUnselect,
}: {
  count: number;
  canEdit: boolean;
  onPaint: (color: string) => void;
  onClearColor: () => void;
  onUnselect: () => void;
}): React.ReactElement | null {
  const [color, setColor] = useState("#244a5c");
  if (!count) return null;
  return (
    <div className="fixed bottom-4 left-1/2 z-50 flex -translate-x-1/2 items-center gap-2 rounded-full border bg-background px-4 py-2 shadow-lg">
      <span className="text-xs font-medium">{count} выбр.</span>
      {canEdit && (
        <>
          <input
            type="color"
            value={color}
            onChange={(e) => setColor(e.target.value)}
            className="size-7 cursor-pointer rounded border"
            title="Цвет строк"
          />
          <Button size="sm" variant="outline" onClick={() => onPaint(color)}>
            Выделить цветом
          </Button>
          <Button size="sm" variant="outline" onClick={onClearColor}>
            Убрать цвет
          </Button>
        </>
      )}
      <Button size="sm" variant="ghost" onClick={onUnselect}>
        Снять выбор
      </Button>
    </div>
  );
}
